<template>
  <el-dialog :visible.sync="visible" width="800px">
    <div>
      <div id="networkChart"></div>
      <el-row>
        <span>网络速度：{{ net_speed }}</span>
        <el-button
          style="margin-left: 12px"
          size="small"
          type="text"
          @click="getNetworkSpeed"
          v-show="isShow"
        >
          刷新
        </el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
let echarts = require("echarts/lib/echarts");
import apis from "@/config/apis";
export default {
  data() {
    return {
      visible:false,
      hard_number:"",
      chart:null,
      net_speed:"",
      isShow:true
    };
  },
  methods: {
    show(row) {
      this.visible = true;
      this.hard_number =row.hard_number;
      this.net_speed = '';
      this.getNetworkData()
    },
     //网络速度
    getNetworkSpeed() {
      this.$axios
        .get(apis.terminal_net_speed+"/"+this.hard_number)
        .then((res) => {
          console.log(res);
          if(res.request.status == 200) {
            this.$message({
              message:'操作成功',
              type: 'success'
            })
          }
          this.net_speed = res.data.data;
        });
    },
    // 网格图
    getNetworkData() {
      this.$axios.post(apis.network_strength,{
        hard_number:this.hard_number
      }).then(res=>{
        console.log(res);
        let trending = res.data.data
        if(trending.length == 0) {
          this.isShow = false
          this.$message({
            type:'error',
            message:'无网络状态'
          })
        }
        let _date = trending.map((item) => {
          // console.log(item);
            return item.time;
          });

          let _network_strength = trending.map((item) => {
            return item.network_strength;
          });
          let option = {
            xAxis: {
              type: "category",
              data: _date,
            },
            yAxis: {
              type: "value",
              axisLabel: {
                formatter: function (value) {
                  var texts = [];
                  if (value === 1) {
                    texts.push("低");
                  } else if (value === 2) {
                    texts.push("中");
                  } else if (value === 3) {
                    texts.push("高");
                  }
                  return texts;
                },
              },
            },
            series: [
              {
                data: _network_strength,
                type: "line",
                smooth: true,
                symbol: 'none'
              },
            ],
          };
          this.chart = echarts.init(document.getElementById("networkChart"));
          this.chart.setOption(option);
      })
    },
  },
  
};
</script>

<style lang="scss" scoped>
#networkChart {
  width: 100%;
  height: 400px;
}</style>
